import React from 'react';
import ReactDOM from 'react-dom';
import { Router, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';
import momentLocalizer from 'react-widgets-moment';
import numberLocalizer from 'react-widgets-simple-number';
import Moment from 'moment';
import MobileDetect from 'mobile-detect';

import routes from '../shared/routes';
import { isEmptyString } from '../shared/validators/formValidators';
import { store } from '../shared/createStore';
import { setClientToken } from './token';
import { installGlobalErrorReporting } from '../shared/helpers/errorReporting';

import '@fontsource-variable/inter';
import '../public/lib/Help.css';
import '../public/lib/Loading.css';
import '../public/lib/LoadingButton.css';
import '../public/lib/EmailConversation.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-widgets/dist/css/react-widgets.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import 'react-credit-cards/es/styles-compiled.css';
import 'react-quill/dist/quill.snow.css';
import 'react-select/dist/react-select.css';
import 'react-table/react-table.css';
import '../public/lib/default.css';
import '../public/lib/receipt.css';
import '../public/lib/polish.css';

try {
    const savedTheme = window.localStorage.getItem('ct-theme');
    if (savedTheme === 'dark' || savedTheme === 'light') {
        document.documentElement.setAttribute('data-theme', savedTheme);
    }
} catch (e) {}

global.__CLIENT__ = true;
global.__SERVER__ = false;
global.__DEVELOPMENT_HTTPS__ = false;
global.__PORT__ = process.env.PORT || 3000;
global.__DEVELOPMENT__ = process.env.NODE_ENV !== 'production';
global.__BLOG_DOMAIN_NAME__ = 'https://casetempo.com';
global.__DOMAIN_NAME__ = __DEVELOPMENT__ ? (__DEVELOPMENT_HTTPS__ ? `https://localhost:${__PORT__}` :
                                                                    `http://localhost:${__PORT__}`) :
                        'https://app.casetempo.com';

global.__IS_MOBILE__ = !isEmptyString(new MobileDetect(window.navigator.userAgent).mobile());

//
// Auto-login hand-off: the server can redirect into the app with
// ?accessToken=<jwt> (e.g. the marketing site's "Try the live app" demo flow).
// Store the token before the router boots and strip it from the URL.
//

try {
    const params = new URLSearchParams(window.location.search);
    const accessToken = params.get('accessToken');
    if (accessToken) {
        setClientToken(accessToken);
        params.delete('accessToken');
        const query = params.toString();
        window.history.replaceState({}, document.title,
            window.location.pathname + (query ? `?${query}` : '') + window.location.hash);
    }
} catch (error) {
    console.error(error);
}

installGlobalErrorReporting();

//
// Set date/time localization.
//

Moment.locale('en');
momentLocalizer(Moment);
numberLocalizer();

//
// Here we put our React instance to the global scope. Make sure you do not put it
// into production and make sure that you close and open your console if the
// DEV-TOOLS does not display
//

if (__DEVELOPMENT__) {
    window.React = React;
}

const history = syncHistoryWithStore(browserHistory, store);

ReactDOM.render((
    <Provider store={store}>
        <Router history={history} children={routes} />
    </Provider>),
    document.getElementById('reactView')
);

if (import.meta.hot) {
    import.meta.hot.accept();
}
